module.exports = __webpack_public_path__ + "img/covid_ss.ed06b2f9.png";